import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import { MAP_LIST } from '$http';
//组件
import areaSelect from 'area-select';

export default {
    components: {
        'area-select': areaSelect
    },
    props: {
        isComShow: {
            default: true
        },
        value: {
            type: Boolean
        }
    },
    data() {
        return {
            visiable: false,
            choiceProjectList: [],
            intentProjectList: MAP_LIST.INTENT_PROJECT,
            defaultData: this.getDefaultData(),
            result: this.getDefaultData(),
            areaInfo: this.getInitAreaData()
        };
    },
    computed: {
        typeList() {
            return this.$store.state.agentTypeList.map(item => {
                return item.Value;
            });
        },
        agentTypeList() {
            return this.$store.state.agentTypeList;
        }
    },
    watch: {
        value(val) {
            this.visiable = val;
        },
        visiable(val) {
            this.$emit('input', val);
        },
        'result.AgentTypeId': function(val) {
            this.result.AgentType = this.typeList[val];
        }
    },
    methods: {
        getInitAreaData() {
            return cloneDeep({
                Provinces_Id: "",
                City_Id: "",
                Area_Id: ""
            });
        },
        getDefaultData() {
            return cloneDeep({
                Customer: '', //客户名称
                Tel: '', //客户电话
                C_Name: '', //主联系人
                Provinces_id: null, //省份ID
                City_id: null, //城市ID
                Area_id: null, //区县ID
                OldEmployee: '', //原属员工
                AgentType: '', //代理商类型
                AgentTypeId: null,
                Code: null, //代理商编号
                PassTimeStart: '', //转正开始时间
                PassTimeEnd: '', //转正结束时间
                ProjectTypes: ''
            });
        },
        getFormdata() {
            this.result.Provinces_id = this.areaInfo.Provinces_Id;
            this.result.City_id = this.areaInfo.City_Id;
            this.result.Area_id = this.areaInfo.Area_Id;
            this.result.ProjectTypes = this.choiceProjectList.join(",");
            return this.result;
        },
        search() {
            let filterData = this.getFormdata();
            this.$emit('search', filterData); // 向上派发 toggle事件
        },
        reset() {
            this.choiceProjectList = [];
            this.result = this.getDefaultData();
            this.areaInfo = this.getInitAreaData();
            this.$refs.areaForm.resetFields();
            this.$emit('reset');
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMFormatAgent/components/complex-search/vm.js